export const configPaths = {
   apiPath : 'https://api.chitfund.blazewebtech.com/api/',
   recordsPerPage : 10
}
